import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'
import type { InsuranceProduct } from 'src/interfaces/insuranceProduct'
import { InsuranceProductForm } from './InsuranceProductForm'
import type {
  InsuranceProductFormMode,
  InsuranceProductFormValues,
} from './InsuranceProductForm.interface'

const FORM_ID = 'insurance-product-form'

interface Props {
  isOpen: boolean
  mode: InsuranceProductFormMode
  insuranceProduct: InsuranceProduct | null
  isSaving: boolean
  onSubmit(values: InsuranceProductFormValues): void
  onClose(): void
}

const InsuranceProductFormModalComponent = ({
  isOpen,
  mode,
  insuranceProduct,
  isSaving,
  onSubmit,
  onClose,
}: Props) => {
  return (
    <CommonModal
      isOpen={isOpen}
      title={mode === 'edit' ? 'Edit insurance product' : 'Add insurance product'}
      // Wider than the default confirm-dialog width: this modal carries a form.
      className={tw`max-w-[480px]`}
      onClose={onClose}
      buttons={
        <Fragment>
          {/* Disabled while the request is in flight so the control matches the page's
              dismissal guard — a Cancel that looks clickable but does nothing is worse. */}
          <Button size="small" color="grey" disabled={isSaving} onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            color="dark"
            type="submit"
            form={FORM_ID}
            loading={isSaving}
            disabled={isSaving}
            data-testid="insurance-product-form-submit-button"
          >
            {mode === 'edit' ? 'Save changes' : 'Create product'}
          </Button>
        </Fragment>
      }
    >
      <InsuranceProductForm
        formId={FORM_ID}
        mode={mode}
        insuranceProduct={insuranceProduct}
        onSubmit={onSubmit}
      />
    </CommonModal>
  )
}

export const InsuranceProductFormModal = memo(InsuranceProductFormModalComponent)
